import React, { useEffect, useState } from 'react';

import Modal from 'react-modal';
import './App.css';
import { useMediaQuery } from 'react-responsive';
import { Route, Switch, useHistory, useLocation, Redirect } from 'react-router-dom';

import presentationBuilderLocalBroker from './Components/LocalBroker/LocalBroker';
import MobileOptionDetail from './Components/OptionDetail/MobileOptionDetail';
import presentationBuilderPDF from './Components/PDF/PresentationPDF/PresentationPDFComponent';
import presentationBuilder from './Components/PresentationComponent';
import providerPreview from './Components/ProviderPreviewComponent';
import { useWindowSize } from './hooks/useWindowSize';
import MobileCoverPageComponent from './MobileTab/MobileCoverPageComponent';
import MobileTotalOptionsComponent from './MobileTab/MobileTotalOptionsComponent';
import MobileTotalOptionsTourDisplayComponent from './MobileTab/MobileTotalOptionsTourDisplayComponent';
import MTTourPageComponent from './MobileTab/MTTourPageComponent';
import * as constNames from './models/constant';
import { Routes as AppRoutes } from './models/routes';
import { setDebug } from './utils/debugger';

setDebug();

Modal.setAppElement('body');

export function getSurveyId(pathParams) {
  for (let i = pathParams.length - 1; i >= 0; i--) {
    if (constNames?.ROUTE_KEYS?.includes(pathParams[i])) {
      return pathParams[i + 1];
    }
  }

  return null;
}

export default function App() {
  const isDesktopOrLaptop = useMediaQuery({ query: constNames.DEVICE_MEDIA.DESKTOP_MIN });
  const history = useHistory();
  const location = useLocation();
  const pathParams = location.pathname.split('/');

  const { deviceInnerScreenWidth } = useWindowSize();

  const getMobileRoutes = (sId) => {
    const mRoutes = [
      `${AppRoutes.MOBILE_BASE}/${sId}/coverpage`,
      `${AppRoutes.MOBILE_BASE}/${sId}/totaloptions`,
      `${AppRoutes.MOBILE_BASE}/${sId}/tourinfo`,
      `${AppRoutes.MOBILE_BASE}/${sId}/tourpage`,
      `${AppRoutes.MOBILE_BASE}/${sId}/options`,
    ];

    return mRoutes;
  };

  useEffect(() => {
    Modal.setAppElement('body');
  }, []);

  // When user change zoom level into one route and want to go another route then replace the zoom level into normal.
  useEffect(() => {
    const handleRouteChange = () => {
      requestAnimationFrame(() => {
        document.body.style.zoom = '100%';
      });
      // Reset zoom level

      setTimeout(() => {
        // On Route change, screen will scroll to top
        window.scrollTo(0, 0);
      }, 10);
    };
    const unListen = history.listen(handleRouteChange);

    return () => {
      unListen();
    };
  }, [history]);

  useEffect(() => {
    if (deviceInnerScreenWidth < constNames.DEVICE_SIZES.desktop) {
      document.body.style.backgroundColor = pathParams.includes('coverpage')
        ? 'rgb(1, 42, 45)'
        : '#fff';
    } else if (deviceInnerScreenWidth > constNames.DEVICE_SIZES.desktop && isDesktopOrLaptop) {
      document.body.style.backgroundColor = '';
    }
  }, [deviceInnerScreenWidth, isDesktopOrLaptop, pathParams]);

  useEffect(() => {
    const surveyId = getSurveyId(pathParams);
    const mobileRoutes = getMobileRoutes(surveyId);
    const [optionDetailsId] = location.pathname.split('/').slice(-1);

    if (deviceInnerScreenWidth > constNames.DEVICE_SIZES.desktop) {
      if (surveyId && mobileRoutes.includes(location.pathname)) {
        history.push(`${AppRoutes.MOBILE_BASE}/${surveyId}`);
      }
    } else if (surveyId && !mobileRoutes.includes(location.pathname)) {
      const isOptionsDetailsRoute = location.pathname.includes(
        `${AppRoutes.MOBILE_BASE}/${surveyId}/options`,
      );

      const newPath =
        isOptionsDetailsRoute && optionDetailsId
          ? `${AppRoutes.MOBILE_BASE}/${surveyId}/options/${optionDetailsId}`
          : `${AppRoutes.MOBILE_BASE}/${surveyId}/coverpage`;

      if (newPath !== location.pathname) {
        history.push(newPath);
      }
    }
  }, [isDesktopOrLaptop, location.pathname, history, pathParams, deviceInnerScreenWidth]);
  useEffect(() => {
    const handleBeforeLoaded = () => {
      window.scrollTo(0, 0);
      // Scroll to the top
    };
    // Attach the event listener

    window.onbeforeunload = handleBeforeLoaded;
    // Clean up the event listener when the component unmounts

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  return (
    <div>
      {deviceInnerScreenWidth > constNames.DEVICE_SIZES.desktop ? (
        <Switch>
          <Route path={AppRoutes.PRESENTATION_BUILDER} component={presentationBuilder} />
          <Route path={AppRoutes.PRESENTATION_BUILDER_PDF} component={presentationBuilderPDF} />
          <Route path={AppRoutes.PREVIEW} component={providerPreview} />
          <Route path={AppRoutes.BROKER_VIEW} component={presentationBuilderLocalBroker} />
        </Switch>
      ) : (
        <Switch>
          <Route
            path={`${AppRoutes.MOBILE_BASE}/:surveyId/coverpage`}
            component={MobileCoverPageComponent}
          />
          <Route
            exact
            path={`${AppRoutes.MOBILE_BASE}/:surveyId/totaloptions`}
            component={MobileTotalOptionsComponent}
          />
          <Route
            exact
            path={`${AppRoutes.MOBILE_BASE}/:surveyId/tourinfo`}
            component={MobileTotalOptionsTourDisplayComponent}
          />
          <Route
            exact
            path={`${AppRoutes.MOBILE_BASE}/:surveyId/tourpage`}
            component={MTTourPageComponent}
          />
          <Route
            exact
            path={`${AppRoutes.MOBILE_BASE}/:surveyId/options/:id`}
            component={MobileOptionDetail}
          />
          <Route path={`${AppRoutes.MOBILE_BASE}/:surveyId`}>
            <Redirect to={`${AppRoutes.MOBILE_BASE}/:surveyId/coverpage`} />
          </Route>
        </Switch>
      )}
    </div>
  );
}
